<template>
  <div class="col-auto">
    <model-table
      :collection="registerType.registerPages"
      :row-name="row => `${row.name} of ${row.parent.parent.name}`"
      :submodel="true"
      :orderable="true"
      :columns="[
        { name: 'type', label: 'Type', field: row => $_.startCase(row.type) },
        { field: 'displayName' },
        { field: 'iconName', label: 'Icon', component: 'icon' },
        { name: 'Related', field: row => row.type === 'button-grid' && row.registerGrid && [row.registerGrid.name] || row.type === 'category' && row.category && [row.category.name] || row.type === 'specific-categorys' && $_.map(row.categories.data, 'name') || '', component: 'chips' },
        { name: 'actions', align: 'right' }
      ]"
    >
      <register-page-form />
    </model-table>
  </div>
</template>

<script>

import RegisterType from 'src/models/register/RegisterType'
import ModelTable from 'src/modules/admin/components/ModelTable'
import RegisterPageForm from 'src/modules/admin/register-type/components/RegisterPageForm'

export default {
  name: 'RegisterPageTable',
  components: {
    ModelTable,
    RegisterPageForm
  },
  props: {
    registerType: {
      type: RegisterType,
      required: true
    }
  }
}

</script>
